// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 2V19L15.4142 19L12 22.4142L8.58579 19H1L1 2L23 2Z"}}]};

const TipsFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tips-filled',
    ref,
    icon: element,
  },
));

TipsFilledIcon.displayName = 'TipsFilledIcon';

export default TipsFilledIcon;
